// src/components/destination/destination-recommendation.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n    previousButton {\n      accessibility\n      analytics {\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        schemaName\n        messageContent\n      }\n    }\n    resource {\n      value\n    }\n    target\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationHeadingFragment on DestinationRecommendationHeading {\n    title\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      resource {\n        value\n      }\n      analytics {\n        referrerId\n        linkName\n      }\n      target\n    }\n    text\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardAttributionFragment on EGDSSpannableText {\n    __typename\n    contents {\n      __typename\n      text\n      ... on EGDSStandardLink {\n        ...EGDSStandardLinkFragment\n      }\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardImageFragment on DestinationRecommendationCardImage {\n    attribution {\n      ...DestinationRecommendationCardAttributionFragment\n    }\n    image {\n      url\n      description\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardMediaFragment on DestinationRecommendationCardMedia {\n    ...DestinationRecommendationCardImageFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationRecommendationCardFragment on DestinationRecommendationCard {\n    heading {\n      ...DestinationRecommendationHeadingFragment\n    }\n    action {\n      ...EGDSUILinkActionFragment\n    }\n    analytics {\n      referrerId\n      linkName\n    }\n    media {\n      ...DestinationRecommendationCardMediaFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment DestinationsContainerFragment on DestinationRecommendationGroup {\n    carousel {\n      ...EGDSCarouselFragment\n    }\n    cards {\n      ...DestinationRecommendationCardFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  query DestinationRecommendationQuery($context: ContextInput!, $recommendationCriteria: DestinationRecommendationCriteriaInput!) {\n    destinationRecommendation(context: $context, recommendationCriteria: $recommendationCriteria) {\n      heading {\n        ...DestinationRecommendationHeadingFragment\n      }\n      ...DestinationsContainerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment OffersRecommendationHeadingFragment on OffersRecommendationHeading {\n    title\n    subTitle\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      description\n      id\n      size\n      theme\n      title\n      withBackground\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    accessibility\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    text\n    size\n    theme\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeListFragment on OffersRecommendationBadges {\n    heading {\n      ...EGDSBadgeFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSProductRatingFragment on ProductRatingSummary {\n    accessibilityLabel\n    primary\n    secondary\n    supportingMessages {\n      ... on EGDSPlainText {\n        text\n      }\n    }\n    theme\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextIconListFragment on EGDSTextIconList {\n    listItems {\n      icon {\n        id\n      }\n      text\n    }\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment OffersRecommendationCardDetailContentFragment on OffersRecommendationCardDetailContent {\n    ...EGDSParagraphFragment\n    ...EGDSTextIconListFragment\n    ...EGDSProductRatingFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment OffersRecommendationCardDetailFragment on OffersRecommendationCardDetail {\n    heading\n    content {\n      ...OffersRecommendationCardDetailContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSImageFragment on Image {\n    aspectRatio\n    description\n    url\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment RecommendationMediaItemAttributionFragment on RecommendationAttribution {\n    content {\n      text\n    }\n    showContent {\n      accessibility\n      icon {\n        id\n        description\n        size\n      }\n    }\n    closeContent {\n      accessibility\n      primary\n    }\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment RecommendationCardMediaFragment on Media {\n    ...EGDSImageFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment RecommendationMediaItemFragment on RecommendationMediaItem {\n    attribution {\n      ...RecommendationMediaItemAttributionFragment\n    }\n    media {\n      ...RecommendationCardMediaFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment OffersRecommendationCardMediaFragment on OffersRecommendationCardMedia {\n    ...EGDSImageFragment\n    ...RecommendationMediaItemFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment TripsSaveItemFragment on TripsSaveItem {\n    initialChecked\n    itemId\n    source\n    attributes {\n      ...TripsSaveStayAttributesFragment\n      ...TripsSaveActivityAttributesFragment\n      ...TripsSaveFlightSearchAttributesFragment\n      ...TripsSaveCarOfferAttributesFragment\n      ...TripsSavePackageAttributesFragment\n    }\n    save {\n      ...TripsSaveItemPropertiesFragment\n    }\n    remove {\n      ...TripsSaveItemPropertiesFragment\n    }\n  }\n\n  fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {\n    checkInDate {\n      ...DateFragment\n    }\n    checkoutDate {\n      ...DateFragment\n    }\n    regionId\n    roomConfiguration {\n      numberOfAdults\n      childAges\n    }\n  }\n\n  fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {\n    regionId\n    dateRange {\n      start {\n        ...DateFragment\n      }\n      end {\n        ...DateFragment\n      }\n    }\n  }\n\n  fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    label\n    tooltip\n  }\n\n  fragment TripsSaveFlightSearchAttributesFragment on TripsSaveFlightSearchAttributes {\n    searchCriteria {\n      primary {\n        journeyCriterias {\n          arrivalDate {\n            ...DateFragment\n          }\n          departureDate {\n            ...DateFragment\n          }\n          destination\n          destinationAirportLocationType\n          origin\n          originAirportLocationType\n        }\n        searchPreferences {\n          advancedFilters\n          airline\n          cabinClass\n        }\n        travelers {\n          age\n          type\n        }\n        tripType\n      }\n      secondary {\n        booleans {\n          id\n          value\n        }\n        counts {\n          id\n          value\n        }\n        dates {\n          id\n          value {\n            ...DateFragment\n          }\n        }\n        ranges {\n          id\n          min\n          max\n        }\n        selections {\n          id\n          value\n        }\n      }\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  fragment TripsSaveCarOfferAttributesFragment on TripsSaveCarOfferAttributes {\n    categoryCode\n    fuelAcCode\n    offerToken\n    searchCriteria {\n      dropOffDateTime {\n        ...DateTimeFragment\n      }\n      dropOffLocation {\n        ...CarRentalLocationFragment\n      }\n      pickUpDateTime {\n        ...DateTimeFragment\n      }\n      pickUpLocation {\n        ...CarRentalLocationFragment\n      }\n    }\n    transmissionDriveCode\n    typeCode\n    vendorCode\n  }\n\n  fragment TripsSavePackageAttributesFragment on TripsSavePackageAttributes {\n    packageOfferId\n    sessionId\n  }\n\n  fragment CarRentalLocationFragment on CarRentalLocation {\n    airportCode\n    coordinates {\n      latitude\n      longitude\n    }\n    isExactLocationSearch\n    regionId\n    searchTerm\n  }\n\n  fragment DateTimeFragment on DateTime {\n    day\n    month\n    year\n    hour\n    minute\n    second\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment OffersRecommendationTripSaveItemFragment on TripsSaveItem {\n    ...TripsSaveItemFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment PropertyPriceFragment on PropertyPrice {\n    ...PriceSummaryFragment\n    options {\n      leadingCaption\n      displayPrice {\n        formatted\n      }\n      disclaimer {\n        value\n      }\n      priceDisclaimer {\n        content\n        primaryButton {\n          text\n        }\n        trigger {\n          icon {\n            description\n          }\n        }\n      }\n      accessibilityLabel\n      strikeOut {\n        formatted\n      }\n      loyaltyPrice {\n        unit\n        amount {\n          formatted\n        }\n        totalStrikeOutPoints {\n          formatted\n        }\n      }\n    }\n    priceMessaging {\n      value\n      theme\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment OffersRecommendationCardFragment on OffersRecommendationCard {\n    impression {\n      referrerId\n      linkName\n      uisPrimeMessages {\n        schemaName\n        messageContent\n      }\n    }\n    tripSaveItem {\n      ...OffersRecommendationTripSaveItemFragment\n    }\n    media {\n      ...OffersRecommendationCardMediaFragment\n    }\n    badges {\n      ...EGDSBadgeListFragment\n      price {\n        ...EGDSBadgeFragment\n      }\n    }\n    heading {\n      ...OffersRecommendationHeadingFragment\n    }\n    details {\n      ...OffersRecommendationCardDetailFragment\n    }\n    price {\n      ...PropertyPriceFragment\n    }\n    cardAction {\n      ...EGDSUILinkActionFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment OffersRecommendationGroupContainerFragment on OffersRecommendationGroup {\n    container {\n      ...EGDSCarouselFragment\n    }\n    cards {\n      ...OffersRecommendationCardFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment OffersRecommendationGroupFragment on OffersRecommendationGroup {\n    impression {\n      referrerId\n      linkName\n    }\n    heading {\n      ...OffersRecommendationHeadingFragment\n    }\n    ...OffersRecommendationGroupContainerFragment\n    moreOffers {\n      ...EGDSStandardLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  query OffersRecommendationByProductQuery(\n    $strategy: OffersRecommendationStrategy\n    $context: ContextInput!\n    $containerType: OffersRecommendationContainerType\n    $productId: String!\n    $productLine: LineOfBusinessDomain!\n  ) {\n    offersRecommendationByProduct(\n      strategy: $strategy\n      context: $context\n      containerType: $containerType\n      productId: $productId\n      productLine: $productLine\n    ) {\n      ...OffersRecommendationGroupFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  query DiscoveryPersonalizedOffersRecommendationQuery($context: ContextInput!, $tripId: String) {\n    personalizedOffersRecommendation(context: $context, tripId: $tripId) {\n      title\n      offers {\n        ...OffersRecommendationGroupFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
import React10 from "react";
import { gql as gql10, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// src/components/destination/__private/destination-recommendation-card/destinations-container.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
// src/components/product/__private/offer-recommendation-card/egds-carousel.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkCarousel } from "uitk-react-carousel";
var __fragment = gql(_templateObject());
var EGDSCarousel = function(param) {
    var data = param.data, children = param.children, peek = param.peek, itemsVisible = param.itemsVisible, _param_enableTracking = param.enableTracking, enableTracking = _param_enableTracking === void 0 ? false : _param_enableTracking;
    var nextButton = data.nextButton, previousButton = data.previousButton;
    var trackerEvent = useClickTracker();
    var lastIndex = React.useRef(0);
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var propertiesToShow = React.useMemo(function() {
        switch(viewSize){
            case defaultViewSizes.SMALL:
                {
                    return itemsVisible.sm;
                }
            case defaultViewSizes.MEDIUM:
                {
                    return itemsVisible.md;
                }
            case defaultViewSizes.LARGE:
                {
                    return itemsVisible.lg;
                }
            default:
                var _itemsVisible_xl;
                return (_itemsVisible_xl = itemsVisible.xl) !== null && _itemsVisible_xl !== void 0 ? _itemsVisible_xl : 4;
        }
    }, [
        viewSize,
        itemsVisible
    ]);
    var itemViewedCallback = React.useCallback(function(nextIndex) {
        if (enableTracking && nextIndex > propertiesToShow) {
            var _button_analytics, _button_analytics1;
            var button = nextIndex >= lastIndex.current ? nextButton : previousButton;
            var _button_analytics_referrerId, _button_analytics_linkName;
            trackerEvent((_button_analytics_referrerId = button === null || button === void 0 ? void 0 : (_button_analytics = button.analytics) === null || _button_analytics === void 0 ? void 0 : _button_analytics.referrerId) !== null && _button_analytics_referrerId !== void 0 ? _button_analytics_referrerId : "", (_button_analytics_linkName = button === null || button === void 0 ? void 0 : (_button_analytics1 = button.analytics) === null || _button_analytics1 === void 0 ? void 0 : _button_analytics1.linkName) !== null && _button_analytics_linkName !== void 0 ? _button_analytics_linkName : "");
        }
        lastIndex.current = nextIndex;
    }, [
        nextButton,
        previousButton,
        lastIndex,
        trackerEvent,
        propertiesToShow,
        enableTracking
    ]);
    var analyticsConfigNavigation = {
        id: "recommendation_module_nav.selected",
        callback: function(moduleName, description) {
            var action = moduleName.includes("scrollRight") || moduleName.includes("scrollLeft");
            if (action) {
                var _button_analytics, _button_analytics1;
                var button = nextButton;
                if (moduleName.includes("scrollLeft")) {
                    button = previousButton;
                }
                var _button_analytics_referrerId, _button_analytics_linkName;
                trackerEvent((_button_analytics_referrerId = button === null || button === void 0 ? void 0 : (_button_analytics = button.analytics) === null || _button_analytics === void 0 ? void 0 : _button_analytics.referrerId) !== null && _button_analytics_referrerId !== void 0 ? _button_analytics_referrerId : "", (_button_analytics_linkName = button === null || button === void 0 ? void 0 : (_button_analytics1 = button.analytics) === null || _button_analytics1 === void 0 ? void 0 : _button_analytics1.linkName) !== null && _button_analytics_linkName !== void 0 ? _button_analytics_linkName : "");
            }
        }
    };
    var _nextButton_accessibility, _previousButton_accessibility;
    return /* @__PURE__ */ React.createElement(UitkCarousel, {
        buttonText: {
            nextButton: (_nextButton_accessibility = nextButton === null || nextButton === void 0 ? void 0 : nextButton.accessibility) !== null && _nextButton_accessibility !== void 0 ? _nextButton_accessibility : "",
            prevButton: (_previousButton_accessibility = previousButton === null || previousButton === void 0 ? void 0 : previousButton.accessibility) !== null && _previousButton_accessibility !== void 0 ? _previousButton_accessibility : ""
        },
        itemsVisible: itemsVisible,
        pageBy: 1,
        peek: peek,
        itemViewedCallback: itemViewedCallback,
        analytics: analyticsConfigNavigation
    }, children);
};
EGDSCarousel.fragment = __fragment;
EGDSCarousel.displayName = "EGDSCarousel";
// src/components/destination/__private/destination-recommendation-card/destination-recommendation-card.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
// src/components/product/__private/offer-recommendation-card/egds-ui-link-action.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCardLink } from "uitk-react-cards";
// src/components/utils/analytics.ts
function sendTracking(analytics, track) {
    track(analytics.referrerId, analytics.linkName, void 0, getMicroMessages(analytics.uisPrimeMessages));
}
function getMicroMessages(uisPrimeMessages) {
    return uisPrimeMessages === null || uisPrimeMessages === void 0 ? void 0 : uisPrimeMessages.map(function(uisPrimeMessage) {
        return {
            messageContent: JSON.parse(uisPrimeMessage.messageContent),
            schemaName: uisPrimeMessage.schemaName
        };
    });
}
// src/__generated__/types.ts
var DestinationRecommendationPlaceType = /* @__PURE__ */ function(DestinationRecommendationPlaceType2) {
    DestinationRecommendationPlaceType2["CITY"] = "CITY";
    DestinationRecommendationPlaceType2["NEIGHBORHOOD"] = "NEIGHBORHOOD";
    DestinationRecommendationPlaceType2["POI"] = "POI";
    return DestinationRecommendationPlaceType2;
}(DestinationRecommendationPlaceType || {});
var DestinationRecommendationStrategy = /* @__PURE__ */ function(DestinationRecommendationStrategy2) {
    DestinationRecommendationStrategy2["NEARBY"] = "NEARBY";
    DestinationRecommendationStrategy2["SIMILAR"] = "SIMILAR";
    DestinationRecommendationStrategy2["TOP"] = "TOP";
    return DestinationRecommendationStrategy2;
}(DestinationRecommendationStrategy || {});
var LineOfBusinessDomain = /* @__PURE__ */ function(LineOfBusinessDomain2) {
    LineOfBusinessDomain2["ACTIVITIES"] = "ACTIVITIES";
    LineOfBusinessDomain2["CAR"] = "CAR";
    LineOfBusinessDomain2["CRUISES"] = "CRUISES";
    LineOfBusinessDomain2["FLIGHT"] = "FLIGHT";
    LineOfBusinessDomain2["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
    LineOfBusinessDomain2["LODGING"] = "LODGING";
    LineOfBusinessDomain2["PACKAGES"] = "PACKAGES";
    LineOfBusinessDomain2["RAILS"] = "RAILS";
    LineOfBusinessDomain2["UNCLASSIFIED"] = "UNCLASSIFIED";
    return LineOfBusinessDomain2;
}(LineOfBusinessDomain || {});
var OffersRecommendationContainerType = /* @__PURE__ */ function(OffersRecommendationContainerType2) {
    OffersRecommendationContainerType2["CAROUSEL"] = "CAROUSEL";
    OffersRecommendationContainerType2["GRID"] = "GRID";
    return OffersRecommendationContainerType2;
}(OffersRecommendationContainerType || {});
var OffersRecommendationStrategy = /* @__PURE__ */ function(OffersRecommendationStrategy2) {
    OffersRecommendationStrategy2["ALTERNATE"] = "ALTERNATE";
    OffersRecommendationStrategy2["ATTACH"] = "ATTACH";
    OffersRecommendationStrategy2["CO_CLICK"] = "CO_CLICK";
    OffersRecommendationStrategy2["NEARBY"] = "NEARBY";
    OffersRecommendationStrategy2["POPULAR"] = "POPULAR";
    OffersRecommendationStrategy2["TRENDING"] = "TRENDING";
    return OffersRecommendationStrategy2;
}(OffersRecommendationStrategy || {});
// src/components/product/__private/offer-recommendation-card/egds-ui-link-action.tsx
var __fragment2 = gql2(_templateObject1());
var EGDSUICardLinkAction = function(param) {
    var data = param.data;
    var resource = data.resource, target = data.target, analytics = data.analytics, accessibility = data.accessibility;
    var href = resource.value;
    var navigationTarget = target === "INTERNAL" /* INTERNAL */  ? "_self" : "_blank";
    var clickTracker = useClickTracker2();
    var onClickCapture = React2.useCallback(function() {
        sendTracking(analytics, clickTracker);
    }, [
        analytics,
        clickTracker
    ]);
    return /* @__PURE__ */ React2.createElement(UitkCardLink, null, /* @__PURE__ */ React2.createElement("a", {
        href: href,
        target: navigationTarget,
        rel: "noopener",
        onClickCapture: onClickCapture,
        "aria-label": accessibility || ""
    }, accessibility));
};
EGDSUICardLinkAction.fragment = __fragment2;
EGDSUICardLinkAction.displayName = "EGDSUICardLinkAction";
// src/components/destination/__private/destination-recommendation-heading.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var __Fragment = gql3(_templateObject2());
var DestinationRecommendationHeading = function(param) {
    var data = param.data, customTitle = param.customTitle, titleProps = param.titleProps;
    var title = data.title;
    return /* @__PURE__ */ React3.createElement(UitkHeading, _object_spread({}, titleProps), customTitle || title);
};
DestinationRecommendationHeading.fragment = __Fragment;
DestinationRecommendationHeading.displayName = "DestinationRecommendationHeading";
// src/components/destination/__private/destination-recommendation-card/destination-card-media/destination-recommendation-card-media.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// src/components/destination/__private/destination-recommendation-card/destination-card-media/destination-recommendation-card-image.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkSpacing } from "uitk-react-spacing";
// src/components/destination/__private/destination-recommendation-card/destination-card-media/destination-recommendation-card-attribution.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLinkSizes as UitkLinkSizes2 } from "uitk-react-link";
import { UitkText as UitkText2 } from "uitk-react-text";
// src/components/product/__private/egds-standard-link.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLink, UitkLinkSizes } from "uitk-react-link";
import { UitkText } from "uitk-react-text";
var _obj;
// src/components/utils/link-target-mapper.ts
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */ , "_self"), _obj);
// src/components/product/__private/egds-standard-link.tsx
var fragment = gql4(_templateObject3());
var EGDSStandardLink = function(param) {
    var data = param.data, textProps = param.textProps, _param_showIcon = param.showIcon, showIcon = _param_showIcon === void 0 ? false : _param_showIcon, _param_linkSize = param.linkSize, linkSize = _param_linkSize === void 0 ? UitkLinkSizes.get("medium") : _param_linkSize, _param_theme = param.theme, theme = _param_theme === void 0 ? "default" : _param_theme, _param_enableTracking = param.enableTracking, enableTracking = _param_enableTracking === void 0 ? false : _param_enableTracking;
    var action = data.action, text = data.text;
    var target = action.target;
    var clickTracker = useClickTracker3();
    var analytics = action.analytics;
    var trackEvent = React4.useCallback(function() {
        if (enableTracking) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        analytics,
        clickTracker,
        enableTracking
    ]);
    var resource = action.resource, accessibility = action.accessibility;
    return /* @__PURE__ */ React4.createElement(UitkLink, {
        onClickCapture: trackEvent,
        size: linkSize,
        theme: theme
    }, /* @__PURE__ */ React4.createElement("a", {
        target: UILinkTargetMap[target],
        rel: "noopener",
        href: resource.value,
        "aria-label": accessibility || ""
    }, textProps ? /* @__PURE__ */ React4.createElement(UitkText, _object_spread({}, textProps), text) : text, !showIcon && /* @__PURE__ */ React4.createElement(UitkIcon, {
        "data-stid": "lodging-link-message-icon",
        name: "arrow_forward",
        size: UitkIconSize.EXTRA_SMALL
    }), accessibility && /* @__PURE__ */ React4.createElement(UitkText, {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment;
EGDSStandardLink.displayName = "EGDSStandardLink";
// src/components/destination/__private/destination-recommendation-card/destination-card-media/destination-recommendation-card-attribution.tsx
var __Fragment2 = gql5(_templateObject4(), EGDSStandardLink.fragment);
var attributionTextProps = {
    theme: "inverse",
    size: 100,
    overflow: "truncate"
};
var DestinationRecommendationCardAttribution = function(param) {
    var data = param.data;
    var text = data.text, contents = data.contents;
    return /* @__PURE__ */ React5.createElement(UitkLayoutFlex, {
        justifyContent: "end",
        alignItems: "center",
        space: "one",
        wrap: "wrap"
    }, contents.map(function(content, index) {
        switch(content === null || content === void 0 ? void 0 : content.__typename){
            case "EGDSStandardLink":
                return /* @__PURE__ */ React5.createElement(UitkLayoutFlex, {
                    key: index,
                    justifyContent: "end",
                    alignItems: "center",
                    space: "one"
                }, /* @__PURE__ */ React5.createElement(EGDSStandardLink, {
                    data: content,
                    textProps: attributionTextProps,
                    linkSize: UitkLinkSizes2.get("small"),
                    showIcon: true,
                    theme: "inverse"
                }));
            default:
                return /* @__PURE__ */ React5.createElement(UitkText2, _object_spread({
                    key: index
                }, attributionTextProps), content.text);
        }
    }), /* @__PURE__ */ React5.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, text));
};
DestinationRecommendationCardAttribution.fragment = __Fragment2;
DestinationRecommendationCardAttribution.displayName = "DestinationRecommendationCardAttribution";
// src/components/destination/__private/destination-recommendation-card/destination-card-media/destination-recommendation-card-image.tsx
var __Fragment3 = gql6(_templateObject5(), DestinationRecommendationCardAttribution.fragment);
var DestinationRecommendationCardImage = function(param) {
    var data = param.data;
    var image = data.image, attribution = data.attribution;
    var url = image === null || image === void 0 ? void 0 : image.url;
    var description = image === null || image === void 0 ? void 0 : image.description;
    return /* @__PURE__ */ React6.createElement(UitkLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React6.createElement(UitkFigure, {
        ratio: UitkFigureAspectRatioType.R16_9,
        roundcorner: [
            "startstart"
        ]
    }, /* @__PURE__ */ React6.createElement(UitkImage, _object_spread_props(_object_spread({}, url ? {
        src: url
    } : {}), {
        alt: description,
        lazyLoading: "lazy",
        placeholderImage: true
    }))), attribution && /* @__PURE__ */ React6.createElement(UitkLayoutPosition, {
        type: "absolute",
        position: {
            left: "zero",
            right: "zero",
            bottom: "zero"
        }
    }, /* @__PURE__ */ React6.createElement(UitkLayoutGrid, {
        columns: [
            "1fr",
            "min-content"
        ],
        space: "one",
        alignItems: "center",
        justifyItems: "end"
    }, /* @__PURE__ */ React6.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React6.createElement(UitkLayoutPosition, {
        type: "relative",
        position: {
            zindex: "layer3"
        }
    }, /* @__PURE__ */ React6.createElement(UitkSpacing, {
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React6.createElement("div", null, /* @__PURE__ */ React6.createElement(DestinationRecommendationCardAttribution, {
        data: attribution
    }))))), /* @__PURE__ */ React6.createElement(UitkSpacing, {
        padding: {
            blockstart: "unset"
        }
    }, /* @__PURE__ */ React6.createElement(UitkScrim, {
        type: UitkScrimType.OVERLAY
    })))));
};
DestinationRecommendationCardImage.fragment = __Fragment3;
DestinationRecommendationCardImage.displayName = "DestinationRecommendationCardImage";
// src/components/destination/__private/destination-recommendation-card/destination-card-media/destination-recommendation-card-media.tsx
var __Fragment4 = gql7(_templateObject6(), DestinationRecommendationCardImage.fragment);
var DestinationRecommendationCardMedia = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "DestinationRecommendationCardImage":
            return /* @__PURE__ */ React7.createElement(DestinationRecommendationCardImage, {
                data: data
            });
        default:
            return null;
    }
};
DestinationRecommendationCardMedia.fragment = __Fragment4;
DestinationRecommendationCardMedia.displayName = "DestinationRecommendationCardMedia";
// src/components/destination/__private/destination-recommendation-card/destination-recommendation-card.tsx
var __Fragment5 = gql8(_templateObject7(), DestinationRecommendationHeading.fragment, EGDSUICardLinkAction.fragment, DestinationRecommendationCardMedia.fragment);
var DestinationRecommendationCard = function(param) {
    var data = param.data;
    var heading = data.heading, action = data.action, media = data.media, analytics = data.analytics;
    return /* @__PURE__ */ React8.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: analytics.referrerId,
        linkName: analytics.linkName
    }, /* @__PURE__ */ React8.createElement(UitkCard, null, /* @__PURE__ */ React8.createElement(DestinationRecommendationCardMedia, {
        data: media
    }), heading && /* @__PURE__ */ React8.createElement(UitkCardContentSection, null, /* @__PURE__ */ React8.createElement(DestinationRecommendationHeading, {
        data: heading
    })), /* @__PURE__ */ React8.createElement(EGDSUICardLinkAction, {
        data: action
    })));
};
DestinationRecommendationCard.fragment = __Fragment5;
DestinationRecommendationCard.displayName = "DestinationRecommendationCard";
// src/components/destination/__private/destination-recommendation-card/destinations-container.tsx
var __Fragment6 = gql9(_templateObject8(), EGDSCarousel.fragment, DestinationRecommendationCard.fragment);
var DestinationsContainer = function(param) {
    var data = param.data;
    var cards = data.cards, carousel = data.carousel;
    return /* @__PURE__ */ React9.createElement(Viewport, null, /* @__PURE__ */ React9.createElement(ViewSmall, null, /* @__PURE__ */ React9.createElement(EGDSCarousel, {
        data: carousel,
        itemsVisible: {
            sm: 1,
            md: 3,
            lg: 5,
            xl: 5
        },
        peek: true,
        enableTracking: true
    }, cards.map(function(item, index) {
        return /* @__PURE__ */ React9.createElement(DestinationRecommendationCard, {
            data: item,
            key: index
        });
    }))), /* @__PURE__ */ React9.createElement(ViewMedium, null, /* @__PURE__ */ React9.createElement(UitkLayoutGrid2, {
        columns: {
            medium: 3,
            large: 4
        },
        space: "three"
    }, cards.map(function(item, index) {
        return /* @__PURE__ */ React9.createElement(UitkLayoutGridItem2, {
            key: index
        }, /* @__PURE__ */ React9.createElement(DestinationRecommendationCard, {
            data: item
        }));
    }))));
};
DestinationsContainer.fragment = __Fragment6;
DestinationsContainer.displayName = "DestinationsContainer";
// src/components/destination/destination-recommendation.tsx
var __Query = gql10(_templateObject9(), DestinationRecommendationHeading.fragment, DestinationsContainer.fragment);
var DestinationRecommendation = function(param) {
    var inputs = param.inputs, title = param.title, skipSsr = param.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.destinationRecommendation)) {
        return null;
    }
    var _data_destinationRecommendation = data.destinationRecommendation, cards = _data_destinationRecommendation.cards, heading = _data_destinationRecommendation.heading;
    if (!cards.length) {
        return null;
    }
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(DestinationRecommendationHeading, {
        data: heading,
        customTitle: title,
        titleProps: {
            tag: "h3",
            size: 4
        }
    }), /* @__PURE__ */ React10.createElement(UitkSpacing2, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React10.createElement("section", null, /* @__PURE__ */ React10.createElement(DestinationsContainer, {
        data: data.destinationRecommendation
    }))));
};
DestinationRecommendation.displayName = "sharedui-DestinationRecommendation";
// src/components/product/product-offers-recommendation.tsx
import React30 from "react";
import { gql as gql31, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/utils/offers-recommendation-group-theme.ts
import { UitkCardBackgroundThemes } from "uitk-react-cards";
var _obj1;
var themeProperties = (_obj1 = {}, _define_property(_obj1, "foundation" /* FOUNDATION */ , {
    itemsVisible: {
        sm: 1,
        md: 3,
        lg: 4,
        xl: 4
    },
    columns: {
        small: 1,
        medium: 3,
        large: 4
    },
    cardBackground: UitkCardBackgroundThemes.PRIMARY,
    cardBorder: true,
    priceAlignment: "end",
    pricePadding: [
        "blockend",
        "inlinestart",
        "inlineend"
    ],
    detailsPadding: true,
    roundedCorners: {
        roundcorner: [
            "startstart",
            "startend"
        ]
    }
}), _define_property(_obj1, "abbreviated" /* ABBREVIATED */ , {
    itemsVisible: {
        sm: 2,
        md: 3,
        lg: 5,
        xl: 5
    },
    columns: {
        small: 2,
        medium: 3,
        large: 5
    },
    cardBackground: UitkCardBackgroundThemes.SECONDARY,
    cardBorder: false,
    priceAlignment: "start",
    pricePadding: false,
    detailsPadding: [
        "blockstart"
    ],
    roundedCorners: {
        roundcorner: true
    }
}), _obj1);
// src/components/product/__private/offers-recommendation-group.tsx
import React29 from "react";
import { gql as gql30 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
// src/components/product/__private/offers-recommendation-group-container-fragment.tsx
import React28, { useEffect } from "react";
import { gql as gql29 } from "@apollo/client";
import { useExperiment } from "@shared-ui/experiment-context";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card.tsx
import React27 from "react";
import { gql as gql28 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
// src/components/product/__private/offers-recommendation-heading.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkHeading as UitkHeading2, UitkText as UitkText3 } from "uitk-react-text";
var __fragment3 = gql11(_templateObject10());
var OffersRecommendationHeading = function(param) /* @__PURE__ */ {
    var data = param.data, titleProps = param.titleProps, subTitleProps = param.subTitleProps, _param_ariaHidden = param.ariaHidden, ariaHidden = _param_ariaHidden === void 0 ? false : _param_ariaHidden;
    var _titleProps_tag;
    return React11.createElement(React11.Fragment, null, ariaHidden && /* @__PURE__ */ React11.createElement(UitkHeading2, {
        tag: (_titleProps_tag = titleProps === null || titleProps === void 0 ? void 0 : titleProps.tag) !== null && _titleProps_tag !== void 0 ? _titleProps_tag : "h4",
        className: "is-visually-hidden"
    }, data.title), /* @__PURE__ */ React11.createElement(UitkHeading2, _object_spread_props(_object_spread({}, titleProps), {
        "aria-hidden": ariaHidden
    }), data.title), data.subTitle && /* @__PURE__ */ React11.createElement(UitkText3, _object_spread({}, subTitleProps), data.subTitle));
};
OffersRecommendationHeading.fragment = __fragment3;
OffersRecommendationHeading.displayName = "OffersRecommendationHeading";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-badge/egds-badge.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkBadge, UitkBadgeSize } from "uitk-react-badge";
// src/components/utils/badge-theme-mapper.ts
import { UitkBadgeTheme } from "uitk-react-badge";
var badgeThemeToUitkThemeMap = {
    DEAL_BUNDLED: UitkBadgeTheme.DEAL_BUNDLED,
    DEAL_GENERIC: UitkBadgeTheme.DEAL_GENERIC,
    DEAL_MEMBER: UitkBadgeTheme.DEAL_MEMBER,
    NOTIFICATION_1: UitkBadgeTheme.NOTIFICATION_1,
    NOTIFICATION_2: UitkBadgeTheme.NOTIFICATION_2,
    VIP: UitkBadgeTheme.VIP,
    LOYALTY_HIGH_TIER: UitkBadgeTheme.LOYALTY_HIGH_TIER,
    LOYALTY_MIDDLE_TIER: UitkBadgeTheme.LOYALTY_MIDDLE_TIER,
    LOYALTY_LOW_TIER: UitkBadgeTheme.LOYALTY_LOW_TIER,
    SPONSORED: UitkBadgeTheme.SPONSORED,
    VIEWED: UitkBadgeTheme.VIEWED,
    SAVED: UitkBadgeTheme.SAVED,
    FAMILY_FRIENDLY: UitkBadgeTheme.FAMILY_FRIENDLY,
    SUPPLIER_PROMO: UitkBadgeTheme.SUPPLIER_PROMO
};
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-badge/egds-graphic.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var __fragment4 = gql12(_templateObject11());
var EGDSGraphic = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "Icon":
            var _data_title, _data_theme;
            return /* @__PURE__ */ React12.createElement(UitkIcon2, {
                description: data.description,
                id: Math.random().toString(),
                name: data.id,
                size: data.size ? UitkIconSize2[data.size] : "EXTRA_SMALL" /* EXTRA_SMALL */ ,
                title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
                theme: (_data_theme = data === null || data === void 0 ? void 0 : data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
                shadow: Boolean(data.withBackground)
            });
        default:
            return null;
    }
};
EGDSGraphic.fragment = __fragment4;
EGDSGraphic.displayName = "EGDSGraphic";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-badge/egds-badge.tsx
var __fragment5 = gql13(_templateObject12(), EGDSGraphic.fragment);
var EGDSBadge = function(param) {
    var data = param.data;
    var graphic = data.graphic, text = data.text, theme = data.theme, size = data.size;
    if (!text && !graphic) {
        return null;
    }
    var themeProps = theme ? badgeThemeToUitkThemeMap[theme] : void 0;
    var badgeSize = size ? UitkBadgeSize[size] : UitkBadgeSize.LARGE;
    return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ React13.createElement(UitkBadge, {
        size: badgeSize,
        theme: themeProps,
        text: text !== null && text !== void 0 ? text : ""
    }, graphic && /* @__PURE__ */ React13.createElement(EGDSGraphic, {
        data: graphic
    })));
};
EGDSBadge.fragment = __fragment5;
EGDSBadge.displayName = "EGDSBadge";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-badge/egds-badge-list.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2 } from "uitk-react-layout-flex";
var __fragment6 = gql14(_templateObject13(), EGDSBadge.fragment);
var EGDSBadgeList = function(param) {
    var data = param.data;
    var heading = data.heading;
    if (!heading.length) {
        return null;
    }
    return /* @__PURE__ */ React14.createElement(UitkLayoutFlex2, {
        direction: "column",
        space: "one",
        alignItems: "start"
    }, heading.map(function(badge, index) {
        return /* @__PURE__ */ React14.createElement(EGDSBadge, {
            data: badge,
            key: index
        });
    }));
};
EGDSBadgeList.fragment = __fragment6;
EGDSBadgeList.displayName = "EGDSBadgeList";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-detail/offers-recommendation-card-detail.tsx
import React19 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-detail/offers-recommendation-card-detail-content.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-detail/egds-paragraph.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkParagraph } from "uitk-react-text";
var __fragment7 = gql15(_templateObject14());
var EGDSParagraph = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React15.createElement(UitkSpacing3, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React15.createElement(UitkParagraph, {
        size: 2
    }, data.text));
};
EGDSParagraph.fragment = __fragment7;
EGDSParagraph.displayName = "EGDSParagraph";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-detail/egds-product-rating.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkBadgeSize as UitkBadgeSize2, UitkBadgeStandard } from "uitk-react-badge";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment2 = gql16(_templateObject15());
var EGDSProductRating = function(param) {
    var data = param.data, ratingStarIcon = param.ratingStarIcon, inline = param.inline;
    var primary = data.primary, secondary = data.secondary, supportingMessages = data.supportingMessages, accessibilityLabel = data.accessibilityLabel, theme = data.theme;
    if (!primary) {
        return null;
    }
    if (theme) {
        var _theme_toLowerCase;
        var badgeTheme = (_theme_toLowerCase = theme === null || theme === void 0 ? void 0 : theme.toLowerCase()) !== null && _theme_toLowerCase !== void 0 ? _theme_toLowerCase : "standard";
        var badgeText = primary.split("/")[0].trim();
        return /* @__PURE__ */ React16.createElement(UitkSpacing4, {
            margin: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React16.createElement(UitkLayoutFlex3, {
            alignItems: "center",
            space: "one"
        }, /* @__PURE__ */ React16.createElement(UitkLayoutFlex3, {
            alignItems: "center"
        }, /* @__PURE__ */ React16.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React16.createElement(UitkBadgeStandard, {
            theme: badgeTheme,
            a11yText: accessibilityLabel || void 0,
            text: badgeText,
            size: UitkBadgeSize2.LARGE
        }))), /* @__PURE__ */ React16.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React16.createElement(UitkLayoutFlex3, {
            direction: inline ? "row" : "column",
            space: inline ? "one" : void 0,
            alignItems: inline ? "center" : void 0
        }, secondary && /* @__PURE__ */ React16.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React16.createElement(UitkText4, {
            weight: "medium"
        }, secondary)), supportingMessages.map(function(item, index) {
            return item.__typename === "EGDSPlainText" && /* @__PURE__ */ React16.createElement(UitkLayoutFlexItem, {
                key: item.text
            }, /* @__PURE__ */ React16.createElement(UitkText4, {
                size: 200
            }, item.text));
        })))));
    }
    return /* @__PURE__ */ React16.createElement(UitkSpacing4, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React16.createElement(UitkLayoutFlex3, {
        direction: "row",
        alignItems: "start"
    }, ratingStarIcon && /* @__PURE__ */ React16.createElement(UitkIcon3, {
        name: "star",
        theme: "negative",
        size: UitkIconSize3.EXTRA_SMALL
    }), /* @__PURE__ */ React16.createElement(UitkLayoutFlex3, {
        wrap: "wrap"
    }, /* @__PURE__ */ React16.createElement(UitkSpacing4, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React16.createElement(UitkText4, {
        weight: "bold",
        theme: "emphasis"
    }, primary)), secondary && /* @__PURE__ */ React16.createElement(UitkSpacing4, {
        margin: {
            inlineend: "one"
        }
    }, /* @__PURE__ */ React16.createElement(UitkText4, {
        size: 300
    }, secondary)), supportingMessages.map(function(item, index) {
        return item.__typename === "EGDSPlainText" && /* @__PURE__ */ React16.createElement(UitkText4, {
            size: 300,
            key: index
        }, item.text);
    }))));
};
EGDSProductRating.fragment = fragment2;
EGDSProductRating.displayName = "ProductRating";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-detail/egds-text-icon-list.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkText as UitkText5 } from "uitk-react-text";
var __fragment8 = gql17(_templateObject16());
var EGDSTextIconList = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React17.createElement(UitkLayoutFlex4, {
        space: "two",
        wrap: "wrap"
    }, data.listItems.map(function(item, index) {
        var _item_icon;
        return /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem2, _object_spread({
            key: index,
            alignSelf: "start"
        }, {
            minWidth: "37x"
        }), /* @__PURE__ */ React17.createElement(UitkLayoutFlex4, {
            space: "two"
        }, item.__typename === "EGDSTextIconListItem" && ((_item_icon = item.icon) === null || _item_icon === void 0 ? void 0 : _item_icon.id) && /* @__PURE__ */ React17.createElement(UitkIcon4, {
            theme: "default",
            name: item.icon.id,
            size: UitkIconSize4.EXTRA_SMALL
        }), /* @__PURE__ */ React17.createElement(UitkText5, {
            theme: "standard",
            size: 200,
            overflow: "truncate-2-lines"
        }, item.text)));
    }));
};
EGDSTextIconList.fragment = __fragment8;
EGDSTextIconList.displayName = "EGDSTextIconList";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-detail/offers-recommendation-card-detail-content.tsx
var __fragment9 = gql18(_templateObject17(), EGDSParagraph.fragment, EGDSTextIconList.fragment, EGDSProductRating.fragment);
var OffersRecommendationCardDetailContent = function(param) {
    var data = param.data, ratingStarIcon = param.ratingStarIcon;
    switch(data === null || data === void 0 ? void 0 : data.__typename){
        case "EGDSParagraph":
            return /* @__PURE__ */ React18.createElement(EGDSParagraph, {
                data: data
            });
        case "EGDSTextIconList":
            return /* @__PURE__ */ React18.createElement(EGDSTextIconList, {
                data: data
            });
        case "ProductRatingSummary":
            return /* @__PURE__ */ React18.createElement(EGDSProductRating, {
                data: data,
                ratingStarIcon: ratingStarIcon,
                inline: true
            });
        default:
            return null;
    }
};
OffersRecommendationCardDetailContent.fragment = __fragment9;
OffersRecommendationCardDetailContent.displayName = "OffersRecommendationCardDetailContent";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-detail/offers-recommendation-card-detail.tsx
var __fragment10 = gql19(_templateObject18(), OffersRecommendationCardDetailContent.fragment);
var OffersRecommendationCardDetail = function(param) {
    var data = param.data, ratingStarIcon = param.ratingStarIcon;
    return /* @__PURE__ */ React19.createElement(React19.Fragment, null, data.heading && /* @__PURE__ */ React19.createElement(UitkHeading3, {
        size: 8,
        tag: "h5"
    }, data.heading), /* @__PURE__ */ React19.createElement(OffersRecommendationCardDetailContent, {
        data: data.content,
        ratingStarIcon: ratingStarIcon
    }));
};
OffersRecommendationCardDetail.fragment = __fragment10;
OffersRecommendationCardDetail.displayName = "OffersRecommendationCardDetail";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/offers-recommendation-card-media.tsx
import React24 from "react";
import { gql as gql24 } from "@apollo/client";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/egds-image.tsx
import React20 from "react";
import { gql as gql20 } from "@apollo/client";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { UitkFigure as UitkFigure2, UitkImage as UitkImage2 } from "uitk-react-images";
// src/components/utils/aspect-ratio-mapper.ts
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType2 } from "uitk-react-images";
var _obj2;
var aspectRatioMapper = (_obj2 = {}, _define_property(_obj2, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType2.R1_1), _define_property(_obj2, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType2.R4_1), _define_property(_obj2, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType2.R4_3), _define_property(_obj2, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType2.R16_9), _define_property(_obj2, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType2.R3_2), _define_property(_obj2, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType2.R3_4), _define_property(_obj2, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType2.R21_9), _obj2);
// src/components/utils/system-events-mapper.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var CLIENT_EVENTS = {
    warningLog: new SystemEvent(SystemEventLevel.WARN, "OFFERS_RECOMMENDATION_CARD_IMAGE_WRONG_URL")
};
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/egds-image.tsx
var __fragment11 = gql20(_templateObject19());
var EGDSImage = function(param) {
    var figureProps = param.figureProps, resourceLink = param.resourceLink, data = param.data;
    var _data_aspectRatio;
    var aspectRatio = aspectRatioMapper[(_data_aspectRatio = data.aspectRatio) !== null && _data_aspectRatio !== void 0 ? _data_aspectRatio : "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ ];
    var systemEvents = useLoggerEvents(CLIENT_EVENTS);
    var log = JSON.stringify(_object_spread_props(_object_spread({}, data), {
        resourceLink: resourceLink
    }));
    return /* @__PURE__ */ React20.createElement(UitkFigure2, _object_spread({
        ratio: aspectRatio
    }, figureProps), /* @__PURE__ */ React20.createElement(UitkImage2, {
        src: data.url,
        alt: data.description,
        placeholderImage: true,
        additionalProps: {
            onError: function() {
                return systemEvents.warningLog.log(log);
            }
        }
    }));
};
EGDSImage.fragment = __fragment11;
EGDSImage.displayName = "EGDSImage";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/recommendation-media-item.tsx
import React23 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/offers-recommendation-media.tsx
import React22 from "react";
import { gql as gql22 } from "@apollo/client";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkScrim as UitkScrim2, UitkScrimType as UitkScrimType2 } from "uitk-react-scrim";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/recommendation-media-item-attribution.tsx
import React21 from "react";
import { gql as gql21 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkIcon as UitkIcon5 } from "uitk-react-icons";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSheetTransition } from "uitk-react-sheet";
import { UitkText as UitkText6 } from "uitk-react-text";
// src/components/utils/uitk-icon-size-mapper.ts
import { UitkIconSize as UitkIconSize5 } from "uitk-react-icons";
var _obj3;
var iconSizeMapper = (_obj3 = {}, _define_property(_obj3, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize5.EXTRA_SMALL), _define_property(_obj3, "SMALL" /* SMALL */ , UitkIconSize5.SMALL), _define_property(_obj3, "MEDIUM" /* MEDIUM */ , UitkIconSize5.MEDIUM), _define_property(_obj3, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize5.MEDIUM), _define_property(_obj3, "LARGE" /* LARGE */ , UitkIconSize5.LARGE), _define_property(_obj3, "XLARGE" /* XLARGE */ , UitkIconSize5.XLARGE), _obj3);
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/recommendation-media-item-attribution.tsx
var __fragment12 = gql21(_templateObject20());
var RecommendationMediaItemAttribution = function(param) {
    var data = param.data;
    var content = data.content, showContent = data.showContent, closeContent = data.closeContent;
    var dialogKey = React21.useMemo(function() {
        return Math.random().toString(36).substr(2, 5);
    }, []);
    var _useDialog = _sliced_to_array(useDialog("recommendation-image-attribution-info-".concat(dialogKey)), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var handleClick = React21.useCallback(function() {
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    var _ref = (showContent === null || showContent === void 0 ? void 0 : showContent.icon) || {}, _ref_id = _ref.id, id = _ref_id === void 0 ? "info_outline" : _ref_id, _ref_description = _ref.description, description = _ref_description === void 0 ? "" : _ref_description, size = _ref.size;
    var triggerRef = React21.useRef(null);
    var _showContent_accessibility, _showContent_accessibility1, _closeContent_primary;
    return /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement(UitkLink2, {
        onClick: handleClick,
        theme: "inverse",
        "aria-label": (_showContent_accessibility = showContent === null || showContent === void 0 ? void 0 : showContent.accessibility) !== null && _showContent_accessibility !== void 0 ? _showContent_accessibility : ""
    }, /* @__PURE__ */ React21.createElement("button", {
        type: "button",
        ref: triggerRef,
        "aria-label": (_showContent_accessibility1 = showContent === null || showContent === void 0 ? void 0 : showContent.accessibility) !== null && _showContent_accessibility1 !== void 0 ? _showContent_accessibility1 : ""
    }, /* @__PURE__ */ React21.createElement(UitkIcon5, {
        id: id,
        name: id,
        title: description,
        size: iconSizeMapper[size !== null && size !== void 0 ? size : "SMALL" /* SMALL */ ]
    }))), /* @__PURE__ */ React21.createElement(UitkSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React21.createElement(DialogComponent, null, /* @__PURE__ */ React21.createElement(UitkDialog, {
        dialogShow: isDialogOpen,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React21.createElement(UitkDialogContent, {
        key: "dialog"
    }, /* @__PURE__ */ React21.createElement(UitkText6, {
        theme: "emphasis"
    }, content.text)), /* @__PURE__ */ React21.createElement(UitkDialogFooter, {
        key: "footer",
        "aria-label": (closeContent === null || closeContent === void 0 ? void 0 : closeContent.accessibility) || "",
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: (_closeContent_primary = closeContent === null || closeContent === void 0 ? void 0 : closeContent.primary) !== null && _closeContent_primary !== void 0 ? _closeContent_primary : "",
            type: "tertiary"
        }
    })))));
};
RecommendationMediaItemAttribution.fragment = __fragment12;
RecommendationMediaItemAttribution.displayName = "RecommendationMediaItemAttribution";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/offers-recommendation-media.tsx
var __fragment13 = gql22(_templateObject21(), EGDSImage.fragment);
var RecommendationCardMedia = function(param) {
    var data = param.data, resourceLink = param.resourceLink, attribution = param.attribution;
    switch(data.__typename){
        case "Image":
            return /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(EGDSImage, {
                data: data,
                resourceLink: resourceLink
            }), attribution && data.url && /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement(UitkLayoutPosition2, {
                type: "absolute",
                position: {
                    bottom: "three",
                    right: "three",
                    zindex: "layer3"
                }
            }, /* @__PURE__ */ React22.createElement(RecommendationMediaItemAttribution, {
                data: attribution
            })), /* @__PURE__ */ React22.createElement(UitkScrim2, {
                type: UitkScrimType2.BOTTOM
            })));
        default:
            return null;
    }
};
RecommendationCardMedia.fragment = __fragment13;
RecommendationCardMedia.displayName = "RecommendationCardMedia";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/recommendation-media-item.tsx
var __fragment14 = gql23(_templateObject22(), RecommendationCardMedia.fragment, RecommendationMediaItemAttribution.fragment);
var RecommendationMediaItem = function(param) {
    var data = param.data, resourceLink = param.resourceLink;
    var attribution = data.attribution, media = data.media;
    var defaultImageMedia = {
        __typename: "Image",
        url: null,
        aspectRatio: null,
        description: ""
    };
    return /* @__PURE__ */ React23.createElement(UitkLayoutPosition3, {
        type: "relative"
    }, /* @__PURE__ */ React23.createElement(RecommendationCardMedia, {
        data: media !== null && media !== void 0 ? media : defaultImageMedia,
        attribution: attribution,
        resourceLink: resourceLink
    }));
};
RecommendationMediaItem.fragment = __fragment14;
RecommendationMediaItem.displayName = "RecommendationMediaItem";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card-media/offers-recommendation-card-media.tsx
var __fragment15 = gql24(_templateObject23(), EGDSImage.fragment, RecommendationMediaItem.fragment);
var OffersRecommendationCardMedia = function(param) {
    var figureProps = param.figureProps, resourceLink = param.resourceLink, data = param.data;
    switch(data.__typename){
        case "Image":
            return /* @__PURE__ */ React24.createElement(EGDSImage, {
                data: data,
                figureProps: figureProps,
                resourceLink: resourceLink
            });
        case "RecommendationMediaItem":
            return /* @__PURE__ */ React24.createElement(RecommendationMediaItem, {
                data: data,
                resourceLink: resourceLink
            });
        default:
            return null;
    }
};
OffersRecommendationCardMedia.fragment = __fragment15;
OffersRecommendationCardMedia.displayName = "OffersRecommendationCardMedia";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-trip-save-item.tsx
import React25 from "react";
import { gql as gql26 } from "@apollo/client";
import { ReactPortalProvider } from "@shared-ui/portal-context";
import { buildStateProvider } from "@shared-ui/provided-state-context";
import { Source, TripSaveItem, ValidatedInputsState } from "@shared-ui/trips-save-item";
// src/components/product/__private/common/trips-save-item-fragment.ts
import { gql as gql25 } from "@apollo/client";
var __TripsSaveItemFragment = gql25(_templateObject24());
// src/components/product/__private/offer-recommendation-card/offers-recommendation-trip-save-item.tsx
var __fragment16 = gql26(_templateObject25(), __TripsSaveItemFragment);
var ValidatedInputsStateProvider = buildStateProvider(new ValidatedInputsState());
var OffersRecommendationTripSaveItem = function(param) {
    var data = param.data;
    var _React25_useState = _sliced_to_array(React25.useState({}), 2), reactPortalContext = _React25_useState[0], setReactPortalContext = _React25_useState[1];
    React25.useEffect(function() {
        setReactPortalContext({
            htmlElement: document.body
        });
    }, []);
    return /* @__PURE__ */ React25.createElement(ReactPortalProvider, {
        reactPortalContext: reactPortalContext
    }, /* @__PURE__ */ React25.createElement(ValidatedInputsStateProvider, null, /* @__PURE__ */ React25.createElement(TripSaveItem, {
        data: data,
        source: Source.LODGING_SEARCH,
        heartLayoutPosition: {
            type: "absolute",
            position: {
                top: "zero",
                right: "zero",
                zindex: "layer3"
            }
        }
    })));
};
OffersRecommendationTripSaveItem.fragment = __fragment16;
OffersRecommendationTripSaveItem.displayName = "OffersRecommendationTripSaveItem";
// src/components/product/__private/offer-recommendation-card/property-price.tsx
import React26 from "react";
import { gql as gql27 } from "@apollo/client";
import { PriceSummary } from "@shared-ui/pricing-price-summary";
import { UitkLayoutFlex as UitkLayoutFlex5 } from "uitk-react-layout-flex";
// src/components/utils/flex-justify-to-align-content-mapper.ts
var flexJustifyToAlignContentMapper = {
    center: "center",
    end: "end",
    start: "start",
    "space-around": "center",
    "space-between": "center"
};
// src/components/product/__private/offer-recommendation-card/property-price.tsx
var __fragment17 = gql27(_templateObject26(), PriceSummary.fragment);
var PropertyPrice = function(param) {
    var flexAlignment = param.flexAlignment, data = param.data, badge = param.badge;
    var alignItems = flexJustifyToAlignContentMapper[flexAlignment !== null && flexAlignment !== void 0 ? flexAlignment : "end"];
    return /* @__PURE__ */ React26.createElement(UitkLayoutFlex5, {
        space: "one",
        direction: "column",
        alignItems: alignItems
    }, badge && /* @__PURE__ */ React26.createElement(EGDSBadge, {
        data: badge
    }), /* @__PURE__ */ React26.createElement(PriceSummary, {
        data: data,
        flexAlignment: flexAlignment
    }));
};
PropertyPrice.fragment = __fragment17;
PropertyPrice.displayName = "PropertyPrice";
// src/components/product/__private/offer-recommendation-card/offers-recommendation-card.tsx
var __fragment18 = gql28(_templateObject27(), OffersRecommendationCardMedia.fragment, OffersRecommendationHeading.fragment, OffersRecommendationCardDetail.fragment, PropertyPrice.fragment, EGDSUICardLinkAction.fragment, OffersRecommendationTripSaveItem.fragment, EGDSBadge.fragment, EGDSBadgeList.fragment);
var OffersRecommendationCard = function(param) {
    var theme = param.theme, data = param.data, ratingStarIcon = param.ratingStarIcon;
    var media = data.media, heading = data.heading, cardAction = data.cardAction, price = data.price, impression = data.impression, details = data.details, tripSaveItem = data.tripSaveItem, badges = data.badges;
    var uisPrimeMessages = impression.uisPrimeMessages, linkName = impression.linkName, referrerId = impression.referrerId;
    var showPrice = price.displayMessages && price.displayMessages.length !== 0;
    return /* @__PURE__ */ React27.createElement(UitkLayoutFlex6, {
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React27.createElement(UitkLayoutFlexItem3, {
        grow: 1
    }, /* @__PURE__ */ React27.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName,
        additionalUisPrimeMicroMessages: getMicroMessages(uisPrimeMessages)
    }, /* @__PURE__ */ React27.createElement(UitkCard2, {
        border: themeProperties[theme].cardBorder,
        backgroundTheme: themeProperties[theme].cardBackground
    }, /* @__PURE__ */ React27.createElement(UitkLayoutFlex6, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React27.createElement("div", null, tripSaveItem && /* @__PURE__ */ React27.createElement(OffersRecommendationTripSaveItem, {
        data: tripSaveItem
    }), (badges === null || badges === void 0 ? void 0 : badges.heading) && /* @__PURE__ */ React27.createElement(UitkLayoutPosition4, {
        type: "absolute",
        position: {
            zindex: "layer1",
            top: "three",
            left: "three"
        }
    }, /* @__PURE__ */ React27.createElement(EGDSBadgeList, {
        data: badges
    })), /* @__PURE__ */ React27.createElement(OffersRecommendationCardMedia, {
        data: media,
        figureProps: themeProperties[theme].roundedCorners,
        resourceLink: cardAction.resource.value
    }), /* @__PURE__ */ React27.createElement(UitkCardContentSection2, {
        padded: themeProperties[theme].detailsPadding
    }, /* @__PURE__ */ React27.createElement(OffersRecommendationHeading, {
        data: heading,
        titleProps: {
            tag: "h4",
            size: 6,
            overflow: "truncate-2-lines"
        },
        subTitleProps: {
            spacing: "one",
            overflow: "truncate-2-lines"
        },
        ariaHidden: true
    }), showPrice && details.map(function(item, index) {
        return /* @__PURE__ */ React27.createElement(OffersRecommendationCardDetail, {
            data: item,
            key: index,
            ratingStarIcon: ratingStarIcon
        });
    }))), showPrice && /* @__PURE__ */ React27.createElement(UitkCardContentSection2, {
        padded: themeProperties[theme].pricePadding
    }, /* @__PURE__ */ React27.createElement(PropertyPrice, {
        data: price,
        badge: badges === null || badges === void 0 ? void 0 : badges.price,
        flexAlignment: themeProperties[theme].priceAlignment
    })), !showPrice && details.map(function(item, index) {
        return /* @__PURE__ */ React27.createElement(UitkCardContentSection2, {
            key: index,
            padded: themeProperties[theme].pricePadding
        }, /* @__PURE__ */ React27.createElement(OffersRecommendationCardDetail, {
            data: item,
            ratingStarIcon: ratingStarIcon
        }));
    }), /* @__PURE__ */ React27.createElement(EGDSUICardLinkAction, {
        data: cardAction
    }))))));
};
OffersRecommendationCard.fragment = __fragment18;
OffersRecommendationCard.displayName = "OffersRecommendationCard";
// src/components/product/__private/offers-recommendation-group-container-fragment.tsx
var __fragment19 = gql29(_templateObject28(), EGDSCarousel.fragment, OffersRecommendationCard.fragment);
var OffersRecommendationGroupContainer = function(param) {
    var theme = param.theme, data = param.data, ratingStarIcon = param.ratingStarIcon, isVrbo = param.isVrbo;
    var _useExperiment = useExperiment("Vrbex_landing_property_recommendations_new_view", false), exposure = _useExperiment.exposure, logExperiment = _useExperiment.logExperiment;
    var cards = data.cards, container = data.container;
    var propertyCards = cards.filter(function(card) {
        return card.details.length > 0 || card.tripSaveItem;
    });
    var shouldLogExposure = Boolean(isVrbo && propertyCards.length > 0);
    useEffect(function() {
        if (shouldLogExposure) {
            logExperiment(exposure);
        }
    }, [
        shouldLogExposure
    ]);
    if (!Array.isArray(cards) || cards.length === 0) {
        return null;
    }
    switch(container === null || container === void 0 ? void 0 : container.__typename){
        case "EGDSCarousel":
            return /* @__PURE__ */ React28.createElement(EGDSCarousel, {
                data: container,
                itemsVisible: themeProperties[theme].itemsVisible,
                peek: true
            }, cards.map(function(card, index) {
                return /* @__PURE__ */ React28.createElement(OffersRecommendationCard, {
                    data: card,
                    key: index,
                    theme: theme,
                    ratingStarIcon: ratingStarIcon
                });
            }));
        default:
            return /* @__PURE__ */ React28.createElement(UitkLayoutGrid3, {
                columns: themeProperties[theme].columns,
                space: "three",
                rows: 2,
                justifyContent: "space-between"
            }, cards.map(function(card, index) {
                return /* @__PURE__ */ React28.createElement(UitkLayoutGridItem3, {
                    key: index
                }, /* @__PURE__ */ React28.createElement(OffersRecommendationCard, {
                    data: card,
                    theme: theme,
                    ratingStarIcon: ratingStarIcon
                }));
            }));
    }
};
OffersRecommendationGroupContainer.fragment = __fragment19;
OffersRecommendationGroupContainer.displayName = "OffersRecommendationGroupContainer";
// src/components/product/__private/offers-recommendation-group.tsx
var __fragment20 = gql30(_templateObject29(), OffersRecommendationHeading.fragment, OffersRecommendationGroupContainer.fragment, EGDSStandardLink.fragment);
var OffersRecommendationGroup = function(param) {
    var theme = param.theme, data = param.data, ratingStarIcon = param.ratingStarIcon, isVrbo = param.isVrbo;
    var heading = data.heading, moreOffers = data.moreOffers, impression = data.impression;
    var _ref = impression || {}, _ref_referrerId = _ref.referrerId, referrerId = _ref_referrerId === void 0 ? "" : _ref_referrerId, _ref_linkName = _ref.linkName, linkName = _ref_linkName === void 0 ? "" : _ref_linkName;
    return /* @__PURE__ */ React29.createElement(IntersectionTracker3, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, heading && /* @__PURE__ */ React29.createElement(Viewport2, null, /* @__PURE__ */ React29.createElement(ViewSmall2, null, /* @__PURE__ */ React29.createElement(OffersRecommendationHeading, {
        titleProps: {
            size: 5
        },
        subTitleProps: {
            spacing: "one",
            size: 300
        },
        data: heading
    })), /* @__PURE__ */ React29.createElement(ViewMedium2, null, /* @__PURE__ */ React29.createElement(OffersRecommendationHeading, {
        titleProps: {
            size: 4
        },
        subTitleProps: {
            spacing: "one",
            size: 300
        },
        data: heading
    }))), /* @__PURE__ */ React29.createElement(UitkSpacing5, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(OffersRecommendationGroupContainer, {
        data: data,
        theme: theme,
        ratingStarIcon: ratingStarIcon,
        isVrbo: isVrbo
    }))), moreOffers && /* @__PURE__ */ React29.createElement(UitkSpacing5, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(EGDSStandardLink, {
        data: moreOffers,
        enableTracking: true
    }))));
};
OffersRecommendationGroup.fragment = __fragment20;
OffersRecommendationGroup.displayName = "OffersRecommendationGroup";
// src/components/product/product-offers-recommendation.tsx
var __Query2 = gql31(_templateObject30(), OffersRecommendationGroup.fragment);
var ProductOffersRecommendation = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var _offersRecommendationByProduct_cards;
    var context = useBexApi2().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    var offersRecommendationByProduct = (data || {}).offersRecommendationByProduct;
    if (loading || error || !offersRecommendationByProduct || ((_offersRecommendationByProduct_cards = offersRecommendationByProduct.cards) === null || _offersRecommendationByProduct_cards === void 0 ? void 0 : _offersRecommendationByProduct_cards.length) === 0) {
        return null;
    }
    return /* @__PURE__ */ React30.createElement(OffersRecommendationGroup, {
        data: offersRecommendationByProduct,
        theme: "foundation" /* FOUNDATION */ 
    });
};
ProductOffersRecommendation.displayName = "sharedui-ProductOffersRecommendation";
// src/components/product/personalized-offers-recommendation.tsx
import React31 from "react";
import { gql as gql32, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex7 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
var __Query3 = gql32(_templateObject31(), OffersRecommendationGroup.fragment);
var PersonalizedOffersRecommendation = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, customTopMargin = param.customTopMargin, ratingStarIcon = param.ratingStarIcon, isVrbo = param.isVrbo, _param_isHeaderHidden = param.isHeaderHidden, isHeaderHidden = _param_isHeaderHidden === void 0 ? false : _param_isHeaderHidden;
    var context = useBexApi3().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery3 = useQuery3(__Query3, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading;
    var _ref = (data === null || data === void 0 ? void 0 : data.personalizedOffersRecommendation) || {}, title = _ref.title, offers = _ref.offers;
    if (loading || error || !(offers === null || offers === void 0 ? void 0 : offers.length) || offers.every(function(offer) {
        var _offer_cards;
        return ((_offer_cards = offer.cards) === null || _offer_cards === void 0 ? void 0 : _offer_cards.length) === 0;
    })) {
        return null;
    }
    var theme = (inputs === null || inputs === void 0 ? void 0 : inputs.tripId) ? "abbreviated" /* ABBREVIATED */  : "foundation" /* FOUNDATION */ ;
    return /* @__PURE__ */ React31.createElement(React31.Fragment, null, title && !isHeaderHidden && /* @__PURE__ */ React31.createElement(Viewport3, null, /* @__PURE__ */ React31.createElement(ViewSmall3, null, /* @__PURE__ */ React31.createElement(UitkHeading4, {
        tag: "h2",
        size: 5
    }, title)), /* @__PURE__ */ React31.createElement(ViewMedium3, null, /* @__PURE__ */ React31.createElement(UitkHeading4, {
        tag: "h2",
        size: 4
    }, title))), /* @__PURE__ */ React31.createElement(UitkSpacing6, {
        margin: {
            blockstart: !isHeaderHidden ? "six" : "unset"
        }
    }, /* @__PURE__ */ React31.createElement(UitkLayoutFlex7, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between",
        space: customTopMargin ? "twelve" : "six"
    }, offers.map(function(offer, index) {
        return /* @__PURE__ */ React31.createElement(UitkSpacing6, {
            margin: {
                blockstart: !customTopMargin || index === 0 ? "unset" : "two"
            },
            key: index
        }, /* @__PURE__ */ React31.createElement("div", null, /* @__PURE__ */ React31.createElement(OffersRecommendationGroup, {
            data: offer,
            theme: theme,
            ratingStarIcon: ratingStarIcon,
            isVrbo: isVrbo
        })));
    }))));
};
PersonalizedOffersRecommendation.displayName = "sharedui-PersonalizedOffersRecommendation";
export { DestinationRecommendation, DestinationRecommendationPlaceType, DestinationRecommendationStrategy, LineOfBusinessDomain, OffersRecommendationContainerType, OffersRecommendationStrategy, PersonalizedOffersRecommendation, ProductOffersRecommendation };
//# sourceMappingURL=index.js.map